import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import _ from 'underscore';

class TermView extends Component {
	constructor(props) {
		super(props);

		this.state = {};
	}

	componentDidMount() {
		window._termRefClick = function(ref) {
			this.props.history.push('/faersla/'+ref);
		}.bind(this);
	}

	formatEntry(html) {
		let formatedHtml = html.replace(/#SA([0-9]+)\$/g, '<sub>$1</sub>');

		formatedHtml = formatedHtml.replace(/<ref idTerm=([0-9]+)>/gm, '<a href="/faersla/$1" onclick="_termRefClick($1); return false;">');

		formatedHtml = formatedHtml.split('</ref>').join('</a>');

		return formatedHtml;
	}

	formatDate(date) {
		let d = new Date(date);

		return d.getDate()+'.'+(d.getMonth()+1)+'.'+d.getFullYear();
	}

	render() {
		let dataItem = this.props.data;

		if (!dataItem.id) {
			return <p>Þessi færsla finnst ekki</p>
		}

		let sortLang = this.props.order || 'IS';

		// Finnum tungumál sem lista er raðað eftir.

		//	Ef röðunarmál er annað en íslenska þá færum við þá færslu fremst í listann yfir orð
		if (dataItem.words.length > 0) {
			dataItem.words = dataItem.words.sort(function(x, y) {
				return x.fklanguage == sortLang ? -1 : y.fklanguage == sortLang ? 1 : 0;
			});
		}

		let isDefinition = dataItem.words.length > 0 ? (_.findWhere(dataItem.words, {fklanguage: 'IS'}) ? _.findWhere(dataItem.words, {fklanguage: 'IS'}).definition : null) : null;

		let WrapperEl = this.props.single ? React.Fragment : 'div';

		let minifiedWords = _.filter(dataItem.words, function(word) {
			return word.word;
		});

		if (dataItem.pictures && dataItem.pictures[0]) {
			let distinctPictures = _.uniq(dataItem.pictures, function(item) {
				return item.id;
			});

			dataItem.pictures = distinctPictures;
		}

		return (
			<React.Fragment>


				{
					dataItem.words.length > 0 &&
					<React.Fragment>
						{
							!this.props.single &&
							<div className={'minified-content'+(this.state.expanded ? ' expanded' : '')} onClick={
								function() {
									this.setState({
										expanded: true
									});
								}.bind(this)}
							>
								{
									minifiedWords.map(function(word, index) {
										return <React.Fragment key={index}>
											{
												index > 0 &&
												<React.Fragment>, </React.Fragment>
											}
											<em>{word.fklanguage}</em>: <strong dangerouslySetInnerHTML={{__html: word.word}} />
											{
												word.abbreviation &&
												<span>, {word.abbreviation}</span>
											}
											{
												word.synonyms &&
												<span> <em>sh</em>: {word.synonyms}</span>
											}

										</React.Fragment>
									})
								}

								{
									isDefinition &&
									<p className="mt-1 mb-1" dangerouslySetInnerHTML={{__html: this.formatEntry(isDefinition)}} />
								}

								{
									dataItem.pictures && dataItem.pictures[0] &&
									<div className="mt-2 image-thumbs">
										{
											dataItem.pictures.map(function(picture, index) {
												return <figure key={index} className="figure">
													<img src={picture.pictureurl} className="figure-img img-fluid rounded" alt="" />
													<figcaption className="figure-caption"></figcaption>
												</figure>;
											})
										}
									</div>
								}


								<div className="mt-2">
									<span className="badge badge-light">Úr orðasafninu <Link to={'/leit//ordabok/'+dataItem.fkdictionary}><em>{window.ordabankiData.dictionaries && window.ordabankiData.dictionaries[dataItem.fkdictionary] ? window.ordabankiData.dictionaries[dataItem.fkdictionary] : dataItem.fkdictionary}</em></Link></span>
								</div>

							</div>
						}

						<WrapperEl className={!this.props.single  ? ('expanded-content'+(this.state.expanded || this.props.single ? ' expanded' : '')) : undefined}>
							<div className="float-right">
								{
									!this.props.single &&
									<Link className="position-relative" style={{zIndex: 1}} to={'/faersla/'+dataItem.id}>
										<span className="badge badge-light">Tengill</span>
									</Link>
								}
							</div>


							{
								dataItem.words.map(function(word, index) {
									let relatedTerms = _.map(dataItem.related, function(related) {
										return _.map(_.filter(related.words, function(relatedWord) {
											return relatedWord.fklanguage == sortLang;
										}), function(relatedWord) {
											return {
												word: relatedWord.word,
												term: related.id
											};
										})[0];
									});

									let compTerms = _.map(dataItem.compterms, function(compterm) {
										return _.map(_.filter(compterm.words, function(relatedWord) {
											return relatedWord.fklanguage == sortLang;
										}), function(relatedWord) {
											return {
												word: relatedWord.word,
												term: compterm.id
											};
										})[0];
									});

									if (word) {

										return <p key={index} className={(word.fklanguage != sortLang ? 'extra-lang' : '')}>
											<span className={'entry-lang-name mb-2'+(word.fklanguage == sortLang ? ' lead' : '')}>
												
												{
													word.fklanguage != sortLang &&
													<React.Fragment><em>{window.ordabankiData.lang ? window.ordabankiData.lang[word.fklanguage] : word.fklanguage}</em>: </React.Fragment>
												}
												<strong dangerouslySetInnerHTML={{__html: word.word}} />
												{
													word.abbreviation &&
													<React.Fragment>, <small>{word.abbreviation}</small></React.Fragment>
												}
												{
													word.fklexcategory &&
													word.fklexcategory
												}
											</span>
											{
												index == 0 && dataItem.category &&
												<span className="d-block mb-2"><strong><em>Flokkun</em></strong>: {dataItem.category}</span>
											}
											{
												word.synonyms &&
												<span className="entry-row"><em>Samheiti</em>: {word.synonyms}</span>
												}
											{
												word.domain &&
												<span className="entry-row"><strong><em>Sérsvið:</em></strong> {word.domain}</span>
											}
											{
												word.definition &&
												<span className="entry-row"><strong><em>Skilgreining:</em></strong> <span dangerouslySetInnerHTML={{__html: this.formatEntry(word.definition)}} /></span>
											}
											{
												word.explanation && word.explanation != '.' &&
												<span className="entry-row"><strong><em>Skýring:</em></strong> <span dangerouslySetInnerHTML={{__html: this.formatEntry(word.explanation)}} /></span>
											}
											{
												word.example && word.example != '.' &&
												<span className="entry-row"><strong><em>Dæmi:</em></strong> <span dangerouslySetInnerHTML={{__html: this.formatEntry(word.example)}} /></span>
											}
											{
												word.fklanguage == sortLang && relatedTerms.length > 0 &&
												<span className="entry-row"><strong><em>Sjá einnig:</em></strong> {relatedTerms.map(function(term, relatedTermIndex) {
													if (term) {
														return <React.Fragment key={relatedTermIndex}><Link to={'/faersla/'+term.term}>{term.word}</Link>{relatedTermIndex < relatedTerms.length-1 && <React.Fragment>, </React.Fragment>}</React.Fragment>;
													}
												})}</span>
											}
											{
												word.fklanguage == sortLang && compTerms.length > 0 &&
												<span className="entry-row"><strong><em>Samanber:</em></strong> {compTerms.map(function(term, compTermIndex) {
													if (term) {
														return <React.Fragment key={compTermIndex}><Link to={'/faersla/'+term.term}>{term.word}</Link>{compTermIndex < compTerms.length-1 && <React.Fragment>, </React.Fragment>}</React.Fragment>;
													}
												})}</span>
											}
										</p>;

									}
									else {
										return null
									}

								}.bind(this))
							}
							{
								dataItem.pictures && dataItem.pictures[0] &&
								<div className="mb-2">
									{
										dataItem.pictures.map(function(picture, index) {
											return <figure key={index} className="figure">
												<img src={picture.pictureurl} className="figure-img img-fluid rounded" alt="" />
												<figcaption className="figure-caption"></figcaption>
											</figure>;
										})
									}
								</div>
							}
							<span className="badge badge-light float-right">
								Úr orðasafninu <Link to={'/leit//ordabok/'+dataItem.fkdictionary}><em>{window.ordabankiData.dictionaries && window.ordabankiData.dictionaries[dataItem.fkdictionary] ? window.ordabankiData.dictionaries[dataItem.fkdictionary] : dataItem.fkdictionary}</em></Link>
								{
									dataItem.changes && dataItem.changes[0] &&
									<span className="font-weihgt-normal">, síðast breytt {this.formatDate(dataItem.changes[0].changedate)}</span>
								}
								{
									(!dataItem.changes || !dataItem.changes[0]) && dataItem.registerdate &&
									<span className="font-weight-normal">, skráð {this.formatDate(dataItem.registerdate)}</span>
								}
							</span>

							<div className="clearfix" />

						</WrapperEl>

					</React.Fragment>
				}

			</React.Fragment>
		);
	}
}

export default withRouter(TermView);



// WEBPACK FOOTER //
// ./src/components/TermView.js